"use client"
import { HttpTypes } from "@medusajs/types"
import { CategoryNavbar, NavbarSearch } from "@/components/molecules"
import { useEffect, useRef, useState } from "react"

export const Navbar = ({
  categories,
}: {
  categories: HttpTypes.StoreProductCategory[]
}) => {
  let categoryWrapper = useRef<HTMLDivElement>(null)
  let [enableClickScroll, setEnableClickScroll] = useState(false)
  useEffect(() => {
    // 有滚动条，进行允许滚动
    if (categoryWrapper.current!.scrollWidth > categoryWrapper.current!.clientWidth) {
      setEnableClickScroll(true)
    }
  }, [])

  const onClickScroll = (xoffset: number) => {
    categoryWrapper.current?.scrollTo({
      behavior: "smooth",
      top: 0,
      left: categoryWrapper.current.scrollLeft + xoffset
    })
  }

  return (
    <div className="flex border py-4 justify-between px-6 items-center gap-2">
      {enableClickScroll && <div onClick={() => onClickScroll(-200)} className="w-[20px] h-[50px] justify-center items-center cursor-pointer hidden md:flex hover:scale-110 transition-all">
        <div className=" w-[10px] h-[10px] border-l-2 border-t-2 border-black -rotate-45"></div>
      </div>}
      <div className="hidden md:flex items-center flex-1 overflow-hidden break-keep whitespace-nowrap" ref={categoryWrapper}>
        <CategoryNavbar categories={categories} />
      </div>
      {enableClickScroll && <div onClick={() => onClickScroll(200)} className="w-[20px] h-[50px] justify-center items-center cursor-pointer hidden md:flex hover:scale-110 transition-all">
        <div className=" w-[10px] h-[10px] border-l-2 border-t-2 border-black rotate-[135deg]"></div>
      </div>}
      <NavbarSearch />
    </div>
  )
}
